// The following polyfills are essential for usage in IE10+.
// Many of these may also exist in the catalogue so `core-js`
// has been added as an "external" dependency to prevent
// duplication in the production bundle.

import 'core-js/es6/promise';
import 'core-js/modules/es6.object.assign';
import 'core-js/modules/es6.array.find';
import 'core-js/modules/es6.array.from';
import 'core-js/modules/es7.array.includes';
import 'core-js/modules/es6.string.includes';
import 'whatwg-fetch';

import Middleware from './Consumer/Components/Middleware';

export default Middleware;
